import React from 'react';
import { Prospect } from '../../shared/types';
import { Map, Plane, Globe, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface PortalTeaserSectionProps {
  prospect: Prospect;
}

export const PortalTeaserSection: React.FC<PortalTeaserSectionProps> = ({ prospect }) => {
  return (
    <section className="py-24 relative overflow-hidden bg-white border-t border-slate-100">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 to-white opacity-50" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[var(--ym-prospect-primary)]/10 text-[var(--ym-prospect-primary)] border border-[var(--ym-prospect-primary)]/20 mb-6">
              <Plane className="w-4 h-4" />
              <span className="text-sm font-semibold tracking-wide uppercase">Portal de Pacotes</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-black text-slate-900 tracking-tighter leading-tight mb-6">
              Sua vitrine <br />
              <span className="text-[var(--ym-prospect-primary)]">pelo mundo.</span>
            </h2>
            
            <p className="text-lg text-slate-600 font-light leading-relaxed mb-8">
              A <strong>{prospect.trade_name}</strong> precisa de muito mais que um site institucional. Você precisa de um portal interativo onde seus clientes possam explorar roteiros, consultar vagas em grupos exclusivos e visualizar pacotes de forma imersiva.
            </p>
            
            <ul className="space-y-4 mb-10">
              {[
                'Catálogo de Destinos Interativo',
                'Páginas Exclusivas por Grupo/Roteiro',
                'Captação Integrada de Leads (WhatsApp)',
              ].map((item, idx) => (
                <li key={idx} className="flex items-center gap-3">
                  <div className="w-6 h-6 rounded-full bg-[var(--ym-prospect-primary)]/10 flex items-center justify-center">
                    <Globe className="w-3 h-3 text-[var(--ym-prospect-primary)]" />
                  </div>
                  <span className="text-slate-700 font-medium">{item}</span>
                </li>
              ))}
            </ul>
            
            <Link 
              to={`/${prospect.slug}/site`} 
              className="inline-flex items-center gap-2 bg-[var(--ym-prospect-primary)] hover:opacity-90 text-white px-8 py-4 rounded-xl font-bold transition-all shadow-sm"
            >
              Visualizar Wireframe do Portal
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>

          <div className="relative aspect-[4/3] rounded-3xl overflow-hidden ym-clean-card group border border-slate-200 shadow-xl bg-white">
            <div className="absolute inset-0 bg-slate-50 opacity-80" />
            <div className="absolute inset-0 flex items-center justify-center">
              <Map className="w-32 h-32 text-slate-200" />
            </div>
            <div className="absolute top-8 left-8 right-8 bottom-0 bg-white rounded-t-2xl border-t border-l border-r border-slate-100 shadow-xl overflow-hidden p-6 transition-transform duration-700 group-hover:-translate-y-4">
              <div className="w-32 h-4 bg-slate-200 rounded-full mb-8" />
              <div className="grid grid-cols-2 gap-4">
                <div className="aspect-square bg-slate-100 rounded-xl" />
                <div className="aspect-square bg-[var(--ym-prospect-primary)]/10 rounded-xl" />
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
  );
};
